import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const ParagraphComponent = ({ paragraph }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);
  const paragraphRef = useRef(null);
  const isHovered = paragraph.id === hoveredDivision;

  const [isparagraphHovered, setIsparagraphHovered] = useState(false);
  const [isparagraphFocused, setIsparagraphFocused] = useState(false);
  const [isparagraphActive, setIsparagraphActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = paragraph;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = paragraph;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = paragraph;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = paragraph;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const generateKeyframes = () => {
    if (!paragraph.keyframes || paragraph.keyframes.length === 0) return null;

    return paragraph.keyframes.map((kf) => {
      const properties = {};
      let transform = "";

      Object.entries(kf.properties).forEach(([key, value]) => {
        // Remove 'KEY' prefix if present
        let processedKey = key.startsWith("KEY") ? key.slice(3) : key;

        // Handle transform properties
        if (
          processedKey === "scale" ||
          processedKey === "translateX" ||
          processedKey === "translateY" ||
          processedKey === "rotate" ||
          processedKey === "skewX" ||
          processedKey === "skewY"
        ) {
          if (value) {
            switch (processedKey) {
              case "scale":
                transform += `scale(${value}) `;
                break;
              case "translateX":
                transform += `translateX(${value}) `;
                break;
              case "translateY":
                transform += `translateY(${value}) `;
                break;
              case "rotate":
                transform += `rotate(${value}) `;
                break;
              case "skewX":
                transform += `skewX(${value}) `;
                break;
              case "skewY":
                transform += `skewY(${value}) `;
                break;
              default:
                break;
            }
          }
        } else {
          // Convert camelCase to kebab-case for other CSS properties
          properties[processedKey] = value;
        }
      });

      // Add transform property if it was built
      if (transform) {
        properties["transform"] = transform.trim();
      }

      return {
        offset: kf.position / 100,
        ...properties,
      };
    });
  };
  useEffect(() => {
    if (
      paragraphRef.current &&
      paragraph.keyframes &&
      paragraph.keyframes.length > 0
    ) {
      const keyframes = generateKeyframes();
      const animation = paragraphRef.current.animate(keyframes, {
        duration: parseFloat(paragraph.animationDuration) * 1000 || 1000,
        delay: parseFloat(paragraph.animationDelay) * 1000 || 0,
        iterations:
          paragraph.animationIterationCount === "infinite"
            ? Infinity
            : parseFloat(paragraph.animationIterationCount) || 1,
        direction: paragraph.animationDirection || "normal",
        fill: paragraph.animationFillMode || "none",
        easing: paragraph.animationTimingFunction || "linear",
      });

      return () => animation.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    paragraph.keyframes,
    paragraph.animationDuration,
    paragraph.animationDelay,
    paragraph.animationIterationCount,
    paragraph.animationDirection,
    paragraph.animationFillMode,
    paragraph.animationTimingFunction,
  ]);

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        paragraph.backgroundImage &&
        paragraph.backgroundImage.startsWith("./")
      ) {
        const imageName = paragraph.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(paragraph.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [paragraph.backgroundImage, files]);

  const focusedStyles =
    isparagraphFocused && paragraph.pseudoClass === "focus"
      ? {
          width: paragraph.focusedwidth || paragraph.width || "100%",
          height: paragraph.focusedheight || paragraph.height || "auto",
          padding: paragraph.focusedpadding || paragraph.padding || "8px",
          paddingTop:
            paragraph.focusedpaddingTop || paragraph.focusedpadding || "8px",
          paddingRight:
            paragraph.focusedpaddingRight || paragraph.focusedpadding || "8px",
          paddingBottom:
            paragraph.focusedpaddingBottom || paragraph.focusedpadding || "8px",
          paddingLeft:
            paragraph.focusedpaddingLeft || paragraph.focusedpadding || "8px",
          margin: paragraph.focusedmargin || paragraph.margin || "0px",
          marginTop:
            paragraph.focusedmarginTop || paragraph.focusedmargin || "0px",
          marginRight:
            paragraph.focusedmarginRight || paragraph.focusedmargin || "0px",
          marginBottom:
            paragraph.focusedmarginBottom || paragraph.focusedmargin || "0px",
          marginLeft:
            paragraph.focusedmarginLeft || paragraph.focusedmargin || "0px",

          borderTop:
            paragraph.focusedborderTop ||
            paragraph.focusedborder ||
            paragraph.border ||
            "1px solid black",
          borderRight:
            paragraph.focusedborderRight ||
            paragraph.focusedborder ||
            paragraph.border ||
            "1px solid black",
          borderBottom:
            paragraph.focusedborderBottom ||
            paragraph.focusedborder ||
            paragraph.border ||
            "1px solid black",
          borderLeft:
            paragraph.focusedborderLeft ||
            paragraph.focusedborder ||
            paragraph.border ||
            "1px solid black",
          borderRadius:
            paragraph.focusedborderRadius || paragraph.borderRadius || "0",

          opacity: paragraph.focusedOpacity || paragraph.opacity || 1,
          color: paragraph.focusedcolor || paragraph.color || "#000",
          backgroundColor:
            paragraph.focusedbackgroundColor ||
            paragraph.backgroundColor ||
            "white",
          boxShadow:
            paragraph.focusedboxShadow || paragraph.boxShadow || "none",

          backgroundImage: (() => {
            if (paragraph.focusedbackgroundImage) {
              if (paragraph.focusedbackgroundImage.startsWith("./")) {
                const imageName = paragraph.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${paragraph.focusedbackgroundImage})`;
            }
            if (paragraph.backgroundImage) {
              if (paragraph.backgroundImage.startsWith("./")) {
                const imageName = paragraph.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${paragraph.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            paragraph.focusedbackgroundPosition ||
            paragraph.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            paragraph.focusedbackgroundSize ||
            paragraph.backgroundSize ||
            "auto",
          backgroundRepeat:
            paragraph.focusedbackgroundRepeat ||
            paragraph.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            paragraph.focusedbackgroundAttachment ||
            paragraph.backgroundAttachment ||
            "scroll",

          fontFamily:
            paragraph.focusedfontFamily || paragraph.fontFamily || "inherit",
          fontSize:
            paragraph.focusedfontSize || paragraph.fontSize || "inherit",
          fontWeight:
            paragraph.focusedfontWeight || paragraph.fontWeight || "normal",
          fontStyle:
            paragraph.focusedfontStyle || paragraph.fontStyle || "normal",
          fontVariant:
            paragraph.focusedfontVariant || paragraph.fontVariant || "normal",
          lineHeight:
            paragraph.focusedlineHeight || paragraph.lineHeight || "normal",
          textShadow:
            paragraph.focusedtextShadow || paragraph.textShadow || "none",
          textAlign:
            paragraph.focusedtextAlign || paragraph.textAlign || "left",
          verticalAlign:
            paragraph.focusedverticalAlign ||
            paragraph.verticalAlign ||
            "baseline",
          textDecoration:
            paragraph.focusedtextDecoration ||
            paragraph.textDecoration ||
            "none",
          textTransform:
            paragraph.focusedtextTransform || paragraph.textTransform || "none",
          letterSpacing:
            paragraph.focusedletterSpacing ||
            paragraph.letterSpacing ||
            "normal",
          wordSpacing:
            paragraph.focusedwordSpacing || paragraph.wordSpacing || "normal",
          textIndent:
            paragraph.focusedtextIndent || paragraph.textIndent || "0",
          whiteSpace:
            paragraph.focusedwhiteSpace || paragraph.whiteSpace || "normal",
          textOverflow:
            paragraph.focusedtextOverflow || paragraph.textOverflow || "clip",
          direction: paragraph.focuseddirection || paragraph.direction || "ltr",
          unicodeBidi:
            paragraph.focusedunicodeBidi || paragraph.unicodeBidi || "normal",
          writingMode:
            paragraph.focusedwritingMode ||
            paragraph.writingMode ||
            "horizontal-tb",

          cursor: paragraph.focusedcursor || paragraph.cursor || "default",
          filter: paragraph.focusedfilter || paragraph.filter || "none",
          backdropFilter:
            paragraph.focusedbackdropFilter ||
            paragraph.backdropFilter ||
            "none",
          mixBlendMode:
            paragraph.focusedmixBlendMode || paragraph.mixBlendMode || "normal",
          transform:
            paragraph.focusedtransform || paragraph.transform || "none",
          transition:
            paragraph.focusedtransition || paragraph.transition || "none",
        }
      : {};

  const hoverStyles =
    isparagraphHovered && paragraph.pseudoClass === "hover"
      ? {
          width: paragraph.hoveredwidth || paragraph.hovered | "100%",
          height: paragraph.hoveredheight || paragraph.hovered || "auto",
          padding: paragraph.hoveredpadding || paragraph.padding || "8px",
          paddingTop:
            paragraph.hoveredpaddingTop || paragraph.hoveredpadding || "8px",
          paddingRight:
            paragraph.hoveredpaddingRight || paragraph.hoveredpadding || "8px",
          paddingBottom:
            paragraph.hoveredpaddingBottom || paragraph.hoveredpadding || "8px",
          paddingLeft:
            paragraph.hoveredpaddingLeft || paragraph.hoveredpadding || "8px",
          margin: paragraph.hoveredmargin || paragraph.margin || "0px",
          marginTop:
            paragraph.hoveredmarginTop || paragraph.hoveredmargin || "0px",
          marginRight:
            paragraph.hoveredmarginRight || paragraph.hoveredmargin || "0px",
          marginBottom:
            paragraph.hoveredmarginBottom || paragraph.hoveredmargin || "0px",
          marginLeft:
            paragraph.hoveredmarginLeft || paragraph.hoveredmargin || "0px",

          borderTop:
            paragraph.hoveredborderTop ||
            paragraph.hoveredborder ||
            paragraph.border ||
            "1px solid black",
          borderRight:
            paragraph.hoveredborderRight ||
            paragraph.hoveredborder ||
            paragraph.border ||
            "1px solid black",
          borderBottom:
            paragraph.hoveredborderBottom ||
            paragraph.hoveredborder ||
            paragraph.border ||
            "1px solid black",
          borderLeft:
            paragraph.hoveredborderLeft ||
            paragraph.hoveredborder ||
            paragraph.border ||
            "1px solid black",
          borderRadius:
            paragraph.hoveredborderRadius || paragraph.borderRadius || "0",

          opacity: paragraph.hoveredOpacity || paragraph.opacity || 1,
          color: paragraph.hoveredcolor || paragraph.color || "#000",
          backgroundColor:
            paragraph.hoveredbackgroundColor ||
            paragraph.backgroundColor ||
            "white",
          boxShadow:
            paragraph.hoveredboxShadow || paragraph.boxShadow || "none",

          backgroundImage: (() => {
            if (paragraph.hoveredbackgroundImage) {
              if (paragraph.hoveredbackgroundImage.startsWith("./")) {
                const imageName = paragraph.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${paragraph.hoveredbackgroundImage})`;
            }
            if (paragraph.backgroundImage) {
              if (paragraph.backgroundImage.startsWith("./")) {
                const imageName = paragraph.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${paragraph.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            paragraph.hoveredbackgroundPosition ||
            paragraph.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            paragraph.hoveredbackgroundSize ||
            paragraph.backgroundSize ||
            "auto",
          backgroundRepeat:
            paragraph.hoveredbackgroundRepeat ||
            paragraph.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            paragraph.hoveredbackgroundAttachment ||
            paragraph.backgroundAttachment ||
            "scroll",

          fontFamily:
            paragraph.hoveredfontFamily || paragraph.fontFamily || "inherit",
          fontSize:
            paragraph.hoveredfontSize || paragraph.fontSize || "inherit",
          fontWeight:
            paragraph.hoveredfontWeight || paragraph.fontWeight || "normal",
          fontStyle:
            paragraph.hoveredfontStyle || paragraph.fontStyle || "normal",
          fontVariant:
            paragraph.hoveredfontVariant || paragraph.fontVariant || "normal",
          lineHeight:
            paragraph.hoveredlineHeight || paragraph.lineHeight || "normal",
          textShadow:
            paragraph.hoveredtextShadow || paragraph.textShadow || "none",
          textAlign:
            paragraph.hoveredtextAlign || paragraph.textAlign || "left",
          verticalAlign:
            paragraph.hoveredverticalAlign ||
            paragraph.verticalAlign ||
            "baseline",
          textDecoration:
            paragraph.hoveredtextDecoration ||
            paragraph.textDecoration ||
            "none",
          textTransform:
            paragraph.hoveredtextTransform || paragraph.textTransform || "none",
          letterSpacing:
            paragraph.hoveredletterSpacing ||
            paragraph.letterSpacing ||
            "normal",
          wordSpacing:
            paragraph.hoveredwordSpacing || paragraph.wordSpacing || "normal",
          textIndent:
            paragraph.hoveredtextIndent || paragraph.textIndent || "0",
          whiteSpace:
            paragraph.hoveredwhiteSpace || paragraph.whiteSpace || "normal",
          textOverflow:
            paragraph.hoveredtextOverflow || paragraph.textOverflow || "clip",
          direction: paragraph.hovereddirection || paragraph.direction || "ltr",
          unicodeBidi:
            paragraph.hoveredunicodeBidi || paragraph.unicodeBidi || "normal",
          writingMode:
            paragraph.hoveredwritingMode ||
            paragraph.writingMode ||
            "horizontal-tb",

          cursor: paragraph.hoveredcursor || paragraph.cursor || "default",
          filter: paragraph.hoveredfilter || paragraph.filter || "none",
          backdropFilter:
            paragraph.hoveredbackdropFilter ||
            paragraph.backdropFilter ||
            "none",
          mixBlendMode:
            paragraph.hoveredmixBlendMode || paragraph.mixBlendMode || "normal",
          transform:
            paragraph.hoveredtransform || paragraph.transform || "none",
          transition:
            paragraph.hoveredtransition || paragraph.transition || "none",
        }
      : {};

  const activeStyles =
    isparagraphActive && paragraph.pseudoClass === "active"
      ? {
          width: paragraph.activatedwidth || paragraph.width || "100%",
          height: paragraph.activatedheight || paragraph.height || "auto",
          padding: paragraph.activatedpadding || paragraph.padding || "8px",
          paddingTop:
            paragraph.activatedpaddingTop ||
            paragraph.activatedpadding ||
            "8px",
          paddingRight:
            paragraph.activatedpaddingRight ||
            paragraph.activatedpadding ||
            "8px",
          paddingBottom:
            paragraph.activatedpaddingBottom ||
            paragraph.activatedpadding ||
            "8px",
          paddingLeft:
            paragraph.activatedpaddingLeft ||
            paragraph.activatedpadding ||
            "8px",
          margin: paragraph.activatedmargin || paragraph.margin || "0px",
          marginTop:
            paragraph.activatedmarginTop || paragraph.activatedmargin || "0px",
          marginRight:
            paragraph.activatedmarginRight ||
            paragraph.activatedmargin ||
            "0px",
          marginBottom:
            paragraph.activatedmarginBottom ||
            paragraph.activatedmargin ||
            "0px",
          marginLeft:
            paragraph.activatedmarginLeft || paragraph.activatedmargin || "0px",

          borderTop:
            paragraph.activatedborderTop ||
            paragraph.activatedborder ||
            paragraph.border ||
            "1px solid black",
          borderRight:
            paragraph.activatedborderRight ||
            paragraph.activatedborder ||
            paragraph.border ||
            "1px solid black",
          borderBottom:
            paragraph.activatedborderBottom ||
            paragraph.activatedborder ||
            paragraph.border ||
            "1px solid black",
          borderLeft:
            paragraph.activatedborderLeft ||
            paragraph.activatedborder ||
            paragraph.border ||
            "1px solid black",
          borderRadius:
            paragraph.activatedborderRadius || paragraph.borderRadius || "0",

          opacity: paragraph.activatedOpacity || paragraph.opacity || 1,
          color: paragraph.activatedcolor || paragraph.color || "#000",
          backgroundColor:
            paragraph.activatedbackgroundColor ||
            paragraph.backgroundColor ||
            "white",
          boxShadow:
            paragraph.activatedboxShadow || paragraph.boxShadow || "none",

          backgroundImage: (() => {
            if (paragraph.activatedbackgroundImage) {
              if (paragraph.activatedbackgroundImage.startsWith("./")) {
                const imageName = paragraph.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${paragraph.activatedbackgroundImage})`;
            }
            if (paragraph.backgroundImage) {
              if (paragraph.backgroundImage.startsWith("./")) {
                const imageName = paragraph.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${paragraph.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            paragraph.activatedbackgroundPosition ||
            paragraph.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            paragraph.activatedbackgroundSize ||
            paragraph.backgroundSize ||
            "auto",
          backgroundRepeat:
            paragraph.activatedbackgroundRepeat ||
            paragraph.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            paragraph.activatedbackgroundAttachment ||
            paragraph.backgroundAttachment ||
            "scroll",

          fontFamily:
            paragraph.activatedfontFamily || paragraph.fontFamily || "inherit",
          fontSize:
            paragraph.activatedfontSize || paragraph.fontSize || "inherit",
          fontWeight:
            paragraph.activatedfontWeight || paragraph.fontWeight || "normal",
          fontStyle:
            paragraph.activatedfontStyle || paragraph.fontStyle || "normal",
          fontVariant:
            paragraph.activatedfontVariant || paragraph.fontVariant || "normal",
          lineHeight:
            paragraph.activatedlineHeight || paragraph.lineHeight || "normal",
          textShadow:
            paragraph.activatedtextShadow || paragraph.textShadow || "none",
          textAlign:
            paragraph.activatedtextAlign || paragraph.textAlign || "left",
          verticalAlign:
            paragraph.activatedverticalAlign ||
            paragraph.verticalAlign ||
            "baseline",
          textDecoration:
            paragraph.activatedtextDecoration ||
            paragraph.textDecoration ||
            "none",
          textTransform:
            paragraph.activatedtextTransform ||
            paragraph.textTransform ||
            "none",
          letterSpacing:
            paragraph.activatedletterSpacing ||
            paragraph.letterSpacing ||
            "normal",
          wordSpacing:
            paragraph.activatedwordSpacing || paragraph.wordSpacing || "normal",
          textIndent:
            paragraph.activatedtextIndent || paragraph.textIndent || "0",
          whiteSpace:
            paragraph.activatedwhiteSpace || paragraph.whiteSpace || "normal",
          textOverflow:
            paragraph.activatedtextOverflow || paragraph.textOverflow || "clip",
          direction:
            paragraph.activateddirection || paragraph.direction || "ltr",
          unicodeBidi:
            paragraph.activatedunicodeBidi || paragraph.unicodeBidi || "normal",
          writingMode:
            paragraph.activatedwritingMode ||
            paragraph.writingMode ||
            "horizontal-tb",

          cursor: paragraph.activatedcursor || paragraph.cursor || "default",
          filter: paragraph.activatedfilter || paragraph.filter || "none",
          backdropFilter:
            paragraph.activatedbackdropFilter ||
            paragraph.backdropFilter ||
            "none",
          mixBlendMode:
            paragraph.activatedmixBlendMode ||
            paragraph.mixBlendMode ||
            "normal",
          transform:
            paragraph.activatedtransform || paragraph.transform || "none",
          transition:
            paragraph.activatedtransition || paragraph.transition || "none",
        }
      : {};

  const paragraphStyle = {
    width: paragraph.width || "100%",
    height: paragraph.height || "50px",
    margin: paragraph.margin || "0",
    marginTop: paragraph.marginTop || paragraph.margin || "0",
    marginRight: paragraph.marginRight || paragraph.margin || "0",
    marginBottom: paragraph.marginBottom || paragraph.margin || "0",
    marginLeft: paragraph.marginLeft || paragraph.margin || "0",
    padding: paragraph.padding || "0",
    paddingTop: paragraph.paddingTop || paragraph.padding || "0",
    paddingRight: paragraph.paddingRight || paragraph.padding || "0",
    paddingBottom: paragraph.paddingBottom || paragraph.padding || "0",
    paddingLeft: paragraph.paddingLeft || paragraph.padding || "0",

    borderTop: isHovered
      ? "1px dashed #555 "
      : paragraph.borderTop || paragraph.border || "none",
    borderRight: isHovered
      ? "1px dashed #555 "
      : paragraph.borderRight || paragraph.border || "none",
    borderBottom: isHovered
      ? "1px dashed #555 "
      : paragraph.borderBottom || paragraph.border || "none",
    borderLeft: isHovered
      ? "1px dashed #555 "
      : paragraph.borderLeft || paragraph.border || "none",
    borderRadius: paragraph.borderRadius || "0",

    fontFamily: paragraph.fontFamily || "inherit",
    fontWeight: paragraph.fontWeight || "inherit",
    fontSize: paragraph.fontSize || "normal",
    fontStyle: paragraph.fontStyle || "inherit",
    fontVariant: paragraph.fontVariant || "inherit",
    lineHeight: paragraph.lineHeight || "inherit",
    textShadow: paragraph.textShadow || "none",
    textAlign: paragraph.textAlign || "inherit",
    verticalAlign: paragraph.verticalAlign || "baseline",
    textDecoration: paragraph.textDecoration || "inherit",
    textTransform: paragraph.textTransform || "inherit",
    letterSpacing: paragraph.letterSpacing || "inherit",
    wordSpacing: paragraph.wordSpacing || "inherit",
    textIndent: paragraph.textIndent || "inherit",
    whiteSpace: paragraph.whiteSpace || "inherit",
    textOverflow: paragraph.textOverflow || "clip",
    direction: paragraph.direction || "ltr",
    unicodeBidi: paragraph.unicodeBidi || "normal",
    writingMode: paragraph.writingMode || "inherit",

    color: paragraph.color || "inherit",
    backgroundColor: paragraph.backgroundColor || "transparent",
    opacity: paragraph.opacity || "1",

    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundRepeat: paragraph.backgroundRepeat || "repeat",
    backgroundPosition: paragraph.backgroundPosition || "0% 0%",
    backgroundSize: paragraph.backgroundSize || "auto",
    backgroundAttachment: paragraph.backgroundAttachment || "scroll",
    backgroundBlendMode: paragraph.backgroundBlendMode || "normal",
    position: paragraph.position || "relative",
    top: paragraph.top || "auto",
    right: paragraph.right || "auto",
    bottom: paragraph.bottom || "auto",
    left: paragraph.left || "auto",
    zIndex: paragraph.zIndex || "auto",
    overflow: paragraph.overflow || "visible",
    boxShadow: paragraph.boxShadow || "none",

    scale: isHovered ? "1.01" : "1",

    ...activeStyles,
    ...hoverStyles,
    ...focusedStyles,
  };

  const createMarkup = () => {
    return { __html: paragraph.text || "paragraph" };
  };

  return (
    <p
      style={paragraphStyle}
      dangerouslySetInnerHTML={createMarkup()}
      onMouseEnter={() => setIsparagraphHovered(true)}
      onMouseLeave={() => setIsparagraphHovered(false)}
      onFocus={() => setIsparagraphFocused(true)}
      onBlur={() => setIsparagraphFocused(false)}
      onMouseDown={() => setIsparagraphActive(true)}
      onMouseUp={() => setIsparagraphActive(false)}
      tabIndex="0"
      ref={paragraphRef}
    />
  );
};

export default ParagraphComponent;
